import React, { useEffect } from 'react';

function HomeChooseUs() {
    
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) el.style.backgroundImage = `url('/${bg}')`;
        });
    }, []);

    return (
        <>
            {/* <!-- Choose Section Begin --> */}
            <section className="choose spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Why People Choose Us</h2>
                                <p>We make the loan process simple, transparent, and fast — so you can focus on what matters most.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch1.png" height="80px" alt="" />
                                <h5>Quick & Easy Process</h5>
                                <p>Apply online in minutes with minimal documentation and zero hassle.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch2.png" height="80px" alt="" />
                                <h5>Absolute Security</h5>
                                <p>Your personal and financial data is fully protected with bank-grade security.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch3.png" height="80px" alt="" />
                                <h5>Quick Approval</h5>
                                <p>Get loan approval within hours and disbursal directly to your bank account.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch4.png" height="80px" alt="" />
                                <h5>Low Interest Rates</h5>
                                <p>Competitive interest rates across all loan products to keep your EMIs affordable.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch5.png" height="80px" alt="" />
                                <h5>100% Transparent</h5>
                                <p>No hidden charges — what you see is what you get. Full clarity at every step.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="choose__item">
                                <img src="img/choose/ch6.png" height="80px" alt="" />
                                <h5>Same Day Disbursal</h5>
                                <p>Approved loans are disbursed the same day so you never miss an opportunity.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Choose Section End --> */}
        </>
    );
}

export default HomeChooseUs;